import React, { useEffect, useId, useRef, useState } from "react";
import InputMask from "react-input-mask";

const InputDefault = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  disabled,
  mask,
  maxLength,
  onBlur,
  error,
  success,
  autoFocus,
  handleKeyDown,
  labelColor,
  onClick,      // 👈 añade
  readOnly,     // 👈 añade
}) => {
  const id = useId();
  const inputRef = useRef(null);

  const [isFocus, setIsFocus] = useState(false);
  const [inputWrapperStyle, setInputWrapperStyle] = useState();
  const [inputStyle, setInputStyle] = useState();
  const [inputLabelStyle, setInputLabelStyle] = useState();

  useEffect(() => {
    const handleClick = (event) => {
      setIsFocus(event?.target === inputRef.current);
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    onInputWrapperStyle();
    onInputLabelStyle();
    onInputStyle();
  }, [value, error, success, disabled]);

  const onInputWrapperStyle = () => {
    setInputWrapperStyle(`input-wrapper ${disabled ? "disabled" : ""} `);
  };

  const onInputLabelStyle = () => {
    setInputLabelStyle(
      `poppins-regular-font ${value || isFocus ? "input-label-focused" : ""}`
    );
  };

  const onInputStyle = () => {
    setInputStyle(`poppins-regular-font ${onInputStatusStyle()}`);
  };

  const onInputStatusStyle = () => {
    return ` ${error ? "input-error" : ""} ${value && success ? "input-success" : ""
      }`;
  };

  return (
    <div className={inputWrapperStyle}>
      {label && (
        <label
          htmlFor={id}
          className={inputLabelStyle}
          style={{ color: labelColor || "inherit" }} // 👈 aquí aplicas el color
        >
          {label}
        </label>
      )}

      {mask ? (
        <InputMask
          mask={mask}
          id={id}
          name={name}
          ref={inputRef}
          className={inputStyle}
          value={value}
          onChange={(onValue) => onChange(onValue.target.value)}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      ) : (
        <input
          id={id}
          onClick={onClick}
          readOnly={readOnly}
          name={name}
          ref={inputRef}
          className={inputStyle}
          value={value}
          onChange={(onValue) => onChange(onValue.target.value)}
          maxLength={maxLength || 100}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onKeyDown={handleKeyDown}
        />
      )}
    </div>
  );
};

export default InputDefault;